// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.identify-toolbar {
    display: flex;
    align-items: center;
    gap: 0.25em;
}

div.identify-mode-hint {
    font-style: italic;
    display: flex;
    align-items: center;
    justify-content: center;
}

div.identify-radius-controls {
    margin-top: 0.25em;
    justify-content: center;
}`, "",{"version":3,"sources":["webpack://./qwc2/components/style/IdentifyTool.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;AAC3B","sourcesContent":["div.identify-toolbar {\n    display: flex;\n    align-items: center;\n    gap: 0.25em;\n}\n\ndiv.identify-mode-hint {\n    font-style: italic;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\ndiv.identify-radius-controls {\n    margin-top: 0.25em;\n    justify-content: center;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
